import React from "react";
import PropTypes from "prop-types";

class LaboratorySuites extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLaboratorySuites: []
    };
  }

  selectedLaboratorySuites = () => {
    const { selectedLaboratorySuites } = this.state;
    return selectedLaboratorySuites;
  };

  onSelected = (laboratorySuite, checked) => {
    const { onSelected } = this.props;
    var { selectedLaboratorySuites } = this.state;
    if (checked) {
      selectedLaboratorySuites = selectedLaboratorySuites.concat(laboratorySuite);
    } else {
      selectedLaboratorySuites = selectedLaboratorySuites.filter(ls => ls !== laboratorySuite);
    }
    this.setState({ selectedLaboratorySuites });
    onSelected(selectedLaboratorySuites);
  };

  render() {
    const { laboratorySuites } = this.props;
    const { selectedLaboratorySuites } = this.state;
    if (laboratorySuites.length == 0) {
      return null;
    }
    return (
      <table className="table table-condensed" style={{ marginBottom: 20 }}>
        <thead>
          <tr>
            <th style={{ width: "10px" }} />
            <th>Name</th>
            <th>Matrix</th>
            <th>Created At</th>
          </tr>
        </thead>
        <tbody>
          {laboratorySuites.map(laboratorySuite => (
            <tr key={laboratorySuite.id}>
              <td>
                <input
                  name="laboratory_suite_id[]"
                  type="checkbox"
                  checked={selectedLaboratorySuites.indexOf(laboratorySuite) >= 0}
                  value={laboratorySuite.id}
                  onChange={event => this.onSelected(laboratorySuite, event.target.checked)}
                />
              </td>
              <td>{laboratorySuite.name}</td>
              <td>{laboratorySuite.matrix_name}</td>
              <td>{laboratorySuite.created_at_f}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}

export default LaboratorySuites;
